// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.restore-pass[data-v-346048da] {\n  display: block;\n  width: 100%;\n}\n.restore-pass__content-wrapper[data-v-346048da] {\n  display: block;\n  width: 100%;\n  max-width: 270px;\n  margin: 0 auto;\n}\n", ""]);
// Exports
module.exports = exports;
